import { useState, useEffect } from 'react';
import { flushSyncQueue, flushGenericOutbox } from '../lib/offline/syncQueue';
import { useAuthStore } from '../store/authStore';
import { useQueryClient } from '@tanstack/react-query';

export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const escolaId = useAuthStore((s) => s.escolaId);
  const queryClient = useQueryClient();

  useEffect(() => {
    const handleOnline = async () => {
      setIsOnline(true);
      try {
        if (escolaId) {
          // Tenta limpar a fila offline de chamadas
          await flushSyncQueue(escolaId);
        }
        // Limpa a fila genérica de outbox (POST/PUT/PATCH/DELETE)
        await flushGenericOutbox();
      } catch (e) {
        console.error('[OfflineSync] Falha no sync automático:', e);
      }
      
      if (escolaId) {
        // Invalida para buscar dados frescos do servidor
        queryClient.invalidateQueries({ queryKey: ['chamadas'] });
        queryClient.invalidateQueries({ queryKey: ['presencas-diarias'] });
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Initial check
    if (navigator.onLine) {
      flushGenericOutbox().catch(console.error);
      if (escolaId) {
        flushSyncQueue(escolaId).catch(console.error);
      }
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [escolaId, queryClient]);

  return isOnline;
}
